export const FETCH_POWERBI_EMBED_CONFIG = "FETCH_POWERBI_EMBED_CONFIG";
export const FETCH_POWERBI_EMBED_CONFIG_SUCCESS = "FETCH_POWERBI_EMBED_CONFIG_SUCCESS";
export const FETCH_POWERBI_EMBED_CONFIG_FAILURE = "FETCH_POWERBI_EMBED_CONFIG_FAILURE";

export const REFRESH_POWERBI_EMBED_TOKEN = "REFRESH_POWERBI_EMBED_TOKEN";
export const REFRESH_POWERBI_EMBED_TOKEN_SUCCESS = "REFRESH_POWERBI_EMBED_TOKEN_SUCCESS";
export const REFRESH_POWERBI_EMBED_TOKEN_FAILURE = "REFRESH_POWERBI_EMBED_TOKEN_FAILURE";

export const SET_CURRENT_DASHBOARD = "SET_CURRENT_DASHBOARD";
export const RESET_DASHBOARD_CACHE = "RESET_DASHBOARD_CACHE";